export default "__VITE_ASSET__73d80d4d__"